import { useCallback, useMemo } from 'react';
import { debounce } from '../../../../../../utils/functions.js';

const useClick = ({ isRowClicked, row, onRowClick, onRowDoubleClick }) => {
    const onClick = useCallback((e) => {
        if (onRowClick &&
            e.target.indeterminate === undefined &&
            !e.target.classList.contains('MuiBackdrop-root')) {
            if (!isRowClicked) {
                row.setRowClicked();
                setTimeout(() => onRowClick(row), 1);
            }
            else {
                row.resetRowClicked();
                setTimeout(() => onRowClick(undefined));
            }
        }
    }, [isRowClicked, onRowClick, row]);
    const onDoubleClick = useCallback((e) => {
        if (e.target.indeterminate === undefined) {
            onRowDoubleClick && onRowDoubleClick(row);
        }
    }, [onRowDoubleClick, row]);
    const onClickDebounced = useMemo(() => debounce((e, count) => {
        if (count === 1) {
            onClick(e);
        }
        else if (count === 2) {
            onDoubleClick(e);
        }
    }, onRowDoubleClick ? 200 : 0), [onClick, onDoubleClick, onRowDoubleClick]);
    return {
        onClick: onClickDebounced,
    };
};

export { useClick };
//# sourceMappingURL=useClick.js.map
